/* eslint-disable linebreak-style */
/* eslint-disable no-console */
/* eslint-disable camelcase */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useAmp } from 'next/amp';
import useDeviceScreen from 'root/hooks/useDeviceScreen';

const getConfig = require('next/config').default;

const { publicRuntimeConfig = {} } = getConfig ? getConfig() : {};

const TaboolaWidget = ({ widget }) => {
  // Get taboola network value from split, because the network change by locale.
  // Our default value to Europe pages are: //cdn.taboola.com/libtrc/grupomcontigo-network/loader.js
  // Example from split return:
  // (4) ["//cdn.taboola.com", "libtrc", "grupomcontigo-network", "loader.js"]
  const taboolaNetwork = publicRuntimeConfig.taboola_loader?.split(/\b-*\//)[2]
    ? publicRuntimeConfig.taboola_loader?.split(/\b-*\//)[2]
    : 'grupomcontigo-network';

  const type2TaboolaOptions = {
    'taboola-below-article-thumbnails': {
      mode: 'alternating-thumbnails-a',
      placement: 'Below Article Thumbnails',
      target_type: 'mix',
    },
    'taboola-right-rail-thumbnails': {
      mode: 'alternating-thumbnails-rr',
      placement: 'Right Rail Thumbnails',
      target_type: 'mix',
    },
    'taboola-right-rail-thumbnails-2nd': {
      mode: 'organic-thumbnails-rr',
      placement: 'Right Rail Thumbnails 2nd',
      target_type: 'mix',
    },
    'taboola-mobile-below-article-thumbnails-amp': {
      mode: 'alternating-thumbnails-b',
      placement: 'Mobile Below Article Thumbnails AMP',
      target_type: 'mix',
    }
  };
  const { isPhone, isTablet, isDesktop } = useDeviceScreen();

  const display = {
    desktop: widget.options?.device?.desktop === 'on',
    tablet: widget.options?.device?.tablet === 'on',
    mobile: widget.options?.device?.mobile === 'on'
  };

  useEffect(() => {
    window._taboola = window._taboola || [];
    window._taboola.push({
      ...type2TaboolaOptions[widget.options.content_type],
      container: widget.options.content_type,
    });
  }, []);

  // a null return when the widget is disable acordding to the display
  if (!((isPhone && display.mobile) || (isTablet && display.tablet)
        || (isDesktop && display.desktop))) {
    return null;
  }

  if (useAmp()) {
    // Check the widget type to change to amp format on below articles
    const type = (widget.options.content_type === 'taboola-below-article-thumbnails')
      ? 'taboola-mobile-below-article-thumbnails-amp'
      : widget.options.content_type;
    return (
      <amp-embed
        data-block-on-consent="_till_responded"
        width="300"
        height="250"
        type="taboola"
        layout="responsive"
        heights="(min-width:1565px) 73%, (min-width:1106px) 79%, (min-width:788px) 88%, (min-width:769px) 117%, (min-width:726px) 90%, (min-width:521px) 103%, (min-width:437px) 140%, (min-width:391px) 565%, (min-width:365px) 596%, 624%"
        data-mode={type2TaboolaOptions[type].mode}
        data-publisher={taboolaNetwork}
        data-target_type={type2TaboolaOptions[type].target_type}
        data-placement={type2TaboolaOptions[type].placement}
        data-article="auto"
      >
      </amp-embed>
    );
  }

  return (
    <div id={widget.options.content_type} />
  );
};

TaboolaWidget.propTypes = {
  widget: PropTypes.object,
};

export default TaboolaWidget;
